import { httpService } from "utils";

import { useReactQuery } from "components/RemoteData";

export const useGetUserSsoTempAppointment = (
  userId: string | null,
  tokenSecurity: string | null
) => {
  if (!userId || !tokenSecurity) {
    throw new Error("UserId not found");
  }

  return useReactQuery(getLoginSsoFormKey(userId), () =>
    getUserSsoTempAppointment(userId, tokenSecurity)
  );
};

//@todo: Przebudować logowanie SSO, jeśli nastąpi powrót z PZ to
// zalogować w aplikacji użtkownika, ale blokować możliwość używania jeśli
// wymagane zgody(może w globalnym storze oznaczyć flagą, że nie potwierdził zgód)
// Bo teraz sztuczne trzeba przekazywać token
const getUserSsoTempAppointment = (userId: string, tokenSecurity: string) => {
  return httpService().get<{ appointmentId: number }>(
    `/e-reservation/user/${userId}/temp-appointment`,
    {
      headers: { "X-Access-Token": `Bearer ${tokenSecurity}` },
    }
  );
};

const getLoginSsoFormKey = (userId: string) => {
  return `user-sso-temp-appointment-${userId}`;
};
